export default "https://cdn-static.gokick.com/assets/f4ff00fe02dd4df624a9917ee1bd81ca642b4b73/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";